import React from 'react';
import { Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Link from '../../Link';
import moment from 'moment';
import { formatIDR } from '../../../utils/formatIDR';

const OngoingBookings = ({ ongoingBookings, loading }) => {

  if (loading) return <div>Loading...</div>; // Or use a proper Loader component if available

  if (!ongoingBookings || ongoingBookings.length === 0) {
    return <div className="alert alert-default">No ongoing bookings.</div>;
  }

  return (
    <Table responsive striped bordered hover className="mb-0">
      <thead>
        <tr>
          <th>Order ID</th>
          <th>Created At</th>
          <th>Status</th>
          <th>Store</th>
          <th>Customer</th>
          <th>Total</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {ongoingBookings.map((booking) => (
          <tr key={booking.id}>
            <td>{booking.orderId}</td>
            <td>
              {moment(booking.bookingCreatedAt).format('YYYY-MM-DD HH:mm:ss')}
              <br />
              <small className='text-muted'>{moment(booking.bookingCreatedAt).fromNow()}</small>
            </td>
            <td>{booking.bookingStatus}</td>
            <td>{booking.shopDetails?.shopName || '-'}</td>
            <td>{booking.customerFullName || '-'}</td>
            <td>{formatIDR(booking.userPayableFare)}</td>
            <td>
              <Link to={`/siteadmin/bookings/view/${booking.id}`} className="btn btn-sm btn-link">
                View
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default injectIntl(OngoingBookings);
